// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Cz-z","smallCardRow":"Dz-z","largeCardRow":"Ez-z","productSearchRow":"Fz-z","curatedRow":"Gz-z"};